export const getIsNonHubSpotFormsEnabled = ({
  leadinSettings: {
    value: {
      formCaptureEnabled
    }
  }
}) => formCaptureEnabled;
export const getCreateMarketableContactsEnabled = ({
  leadinSettings: {
    value: {
      createMarketableContactsEnabled
    }
  }
}) => createMarketableContactsEnabled;